export function lowercaseString(str) {
  if (!str) return "";
  return typeof str === "string" ? str.toLowerCase() : "";
}

export function getCoreDigits(phone, isCanada) {
  let digits = phone.toString().replace(/\D/g, '');
  if (isCanada) {
    if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  } else {
    if (digits.length === 12 && digits.startsWith('92')) digits = digits.slice(2);
    else if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1);
  }
  return digits;
}

/**
 * Validates a phone number.
 * Only checks for presence and numeric format (allowing leading +).
 * @param {string} phone
 * @returns {{ valid: boolean, message: string }}
 */
export function validatePhone(phone) {
  const str = phone ? phone.toString().trim() : '';
  if (!str) return { valid: false, message: 'Phone number is required' };

  // Check if it's numeric (allowing a leading +)
  const numericPattern = /^\+?[0-9]+$/;
  if (!numericPattern.test(str)) {
    return { valid: false, message: 'Phone number must be numeric' };
  }

  // Check length (usually 10-15 digits for international numbers)
  const digits = str.replace(/\D/g, '');
  if (digits.length < 10) {
    return { valid: false, message: 'Phone number must be at least 10 digits' };
  }
  if (digits.length > 15) {
    return { valid: false, message: 'Phone number cannot exceed 16 digits' };
  }

  return { valid: true, message: '' };
}

export const isCanadaHospital = () => {
  const hospitalId = localStorage.getItem('hospitalId');
  return hospitalId === '68d68a07d3f9b7819cd05e80';
}

export const isAdvancedEyeDomain = () => {
  const hospitalId = localStorage.getItem('hospitalId');
  const hostname = window.location.hostname;
  return hostname.includes("advancedeye") || hostname.includes("advanced-eye") || hospitalId === '68d68a07d3f9b7819cd05e80';
}